import { lazy, Suspense } from 'react'
import { useOrganization } from '../contexts/OrganizationContext'
import { PRODUCT_KEYS } from '../config/studioProducts'
import { PageHeader, PageLayout, StatePanel } from '../components/common'

// The dashboard loads on demand, like Feed's Growth page: the chart and grid
// code is only paid for when an operator opens the page.
const GrowthDashboard = lazy(() => import('../components/growth/GrowthDashboard').then((module) => ({ default: module.GrowthDashboard })))

// Phase 1 (#667) is the product-agnostic Growth shell pointed at Prepacks.
// There are no Performance or Experiments tabs here: the page is the dashboard
// and nothing else yet.
function PrepacksGrowthPage() {
  const { currentOrg } = useOrganization()
  const slug = currentOrg?.slug

  const content = !slug ? (
    <StatePanel state="restricted" title="Select an organization" description="Choose an organization before opening Prepacks Growth." />
  ) : (
    <Suspense fallback={<StatePanel state="loading" title="Loading dashboard" compact />}>
      <GrowthDashboard product={PRODUCT_KEYS.PREPACKS} org={currentOrg} />
    </Suspense>
  )

  return (
    <PageLayout size="wide">
      <PageHeader title="Growth" context="Prepacks" />
      {content}
    </PageLayout>
  )
}

export default PrepacksGrowthPage
